module.exports = __webpack_public_path__ + "static/MissionLabs_Logo_Horizontal_Strapline-45a65c2bef4ae03f6a4f1d5acc657cea.svg";